@if (layersForDisplay().length) {
  <div id="map-legend-widget">
    @for (layer of layersForDisplay(); track layer.uId) {
      <div class="legend-layer-info">
        <div class="layer-marker-pin" [class.is-teardrop]="!layer.customMarkerImage && layer.markerName === 'pin-teardrop'">
          @if (layer.customMarkerImage) {
            <img class="custom-marker" [src]="layer.customMarkerImage" />
          } @else {
            @switch (layer.markerName) {
              @case ('pin-teardrop') {
                <topo-teardrop-svg [color]="layer.color" />
              }
              @case ('pin-square') {
                <topo-square-svg [color]="layer.color" />
              }
              @default {
                <topo-circle-svg [color]="layer.color" />
              }
            }
          }

          @if (layer.iconPath) {
            @if (layer.iconPath.indexOf('data:') >= 0) {
              <img class="layer-icon" [src]="layer.iconPath" />
            } @else {
              <i class="material-icons layer-icon" style="color: white">{{ layer.iconPath }}</i>
            }
          }
        </div>

        <span class="layer-name">{{ layer.name }}</span>
      </div>
    }
  </div>
}
